<template>
  <div class="lang-set lang-set1" >
    <a-dropdown>
      <span class="ant-dropdown-link">
        <span class="right-content__action"><svg-icon iconfont :name="languageCodes[currentLang]" style="font-size:18px"></svg-icon></span>
      </span>
      <a-menu slot="overlay" :selectedKeys="[`${currentLang}`]">
        <a-menu-item :key="locale"  v-for="locale in locales" @click="changeLang" :class="[languageIcons[locale] === 'KR' ? 'p-l-3' : '']">
          <span class='language-icon'>
            <svg-icon :name="languageIcons[locale]" :class="[languageIcons[locale] === 'KR' ? 'fz-24' : '']"></svg-icon>
            <span>{{languageLabels[locale]}}</span>
          </span>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
  </div>
</template>

<script>
import i18nMixin from '@/store/i18n-mixin'
import { LANGUAGE, ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  name: 'SelectLang',
  mixins: [i18nMixin],
  data () {
    return {
      ACCESS_TOKEN: this.$ls.get(ACCESS_TOKEN) || null,
      locales: ['zh_CN', 'en_US', 'ko_KR'].slice(0, 2),
      languageLabels: {
        'zh_CN': '简体中文',
        'zh_TW': '繁体中文',
        'en_US': 'English',
        'pt_BR': 'Português',
        'ko_KR': '한국어'
      },
      languageIcons: {
        'zh_CN': 'CN',
        'en_US': 'US',
        'ko_KR': 'KR'
      },
      languageCodes: this.$root.languageCodes({
        'zh_CN': 'open-icon-shangdaohang-zhongwen',
        'ko_KR': 'open-icon-shangdaohang-hanwen',
        'en_US': 'open-icon-shangdaohang-yingwen'
      }, 'toUpperCase')
    }
  },
  methods: {
    changeLang ({ key } = {}) {
      key = key || this.$ls.get(LANGUAGE)
      this.setLang(key || 'zh_CN', !!this.ACCESS_TOKEN)
    }
  }
}
</script>

<style lang="less" scoped>
.lang-set1 {
  color: #fff;
  text-align: center;
  .right-content__action {
    height: 100%;
    padding: 0 11px;
    display: inline-flex;
    font-size: 12px;
    white-space: nowrap;
    cursor: pointer;
    transition: all 0.3s;
    align-items: center;
  }
  &.lang-set-login {
    .ant-dropdown-trigger.ant-dropdown-open {
      color: #4075FD;
      background: transparent;
      cursor: pointer;
      .up-transform {
        transform:rotate(180deg);
      }
    }
  }
  .ant-dropdown-link {
    height: 64px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
  }
  .ant-dropdown-trigger {
    font-size: 16px;
    .up-transform {
      transition:All 0.3s ease-in-out;
      margin-left: 5px;
    }
    &.ant-dropdown-open {
      background-color: rgba(255, 255, 255, 0.2);
      cursor: pointer;
      .up-transform {
        transform:rotate(180deg);
      }
    }
  }
}
.lang-set2 {
  // margin-right: 3px;
  color: #fff;
  // min-width: 113px;
  text-align: center;
  .right-content__action {
    height: 100%;
    padding: 0 11px;
    display: inline-flex;
    // color: #ffffff;
    font-size: 12px;
    white-space: nowrap;
    cursor: pointer;
    transition: all 0.3s;
    align-items: center;
  }
  &.lang-set-login {
    .ant-dropdown-trigger.ant-dropdown-open {
      color: #4075FD;
      background: transparent;
      cursor: pointer;
      .up-transform {
        transform:rotate(180deg);
      }
    }
  }
  .ant-dropdown-link {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
  }
  .ant-dropdown-trigger {
    font-size: 16px;
    .up-transform {
      transition:All 0.3s ease-in-out;
      margin-left: 5px;
    }
    &.ant-dropdown-open {
      // color: #fff;
      background-color: rgba(255, 255, 255, 0.2);
      cursor: pointer;
      .up-transform {
        transform:rotate(180deg);
      }
    }
  }
}
.lang-set-menu {
  padding: 0;
  margin-top: -3px;
  border-radius: 0;
  li {
    display: flex;
    border-top: 1px #eee solid;
    padding: 8px 12px;
    &:first-child {
      border-top: none
    }
    span:nth-child(1) {
      width: 25px;
      margin-right: 5px;
      text-align: right;
    }
    &:hover {
      color: #1890ff;
      background-color: #e6f7ff;
    }
  }
}
.ant-dropdown-menu-item {
  .language-icon {
    display: flex;
    justify-content: left;
    align-items: center;
    .icon-svg {
      font-size:18px;
      margin-right:8px;
    }
  }
}

.ant-dropdown-menu-item {
  &:hover {
    color: #077BFC;
  }
}
.fz-24 {
  font-size: 22px!important;
  margin-right: 6px!important;
}
.p-l-3 {
  padding-left: 10px!important;
}
</style>
